export default {
  登录已过期: 'Đăng nhập đã hết hạn',
  查询地址户信息: 'Truy vấn thông tin địa chỉ hộ gia đình',
  获取地址户信息失败: 'Không thể lấy được thông tin tài khoản địa chỉ',
  保存收货地址失败: 'Không lưu được địa chỉ giao hàng',
  收货地址: 'Địa chỉ giao hàng',
  名字: 'Tên',
  请输入名字: 'Vui lòng nhập tên',
  手机号: 'Số điện thoại',
  请输入手机号: 'Vui lòng nhập số điện thoại',
  请输入邮箱: 'Vui lòng nhập địa chỉ email của bạn',
  地址: 'Địa chỉ',
  请选择地区: 'Vui lòng chọn khu vực',
  请输入详细地址: 'Vui lòng nhập địa chỉ chi tiết',
  保存: 'Cứu',
  今天: 'Hôm nay',
  本月: 'Tháng này',
  本季: 'Mùa này',
  本年: 'Năm nay',
  自定义时间: 'Thời gian tùy chỉnh',
  至: 'ĐẾN',
  取消: 'Hủy bỏ',
  确认: 'Xác nhận',
  总库存小于起订量: 'Tổng số hàng tồn kho ít hơn số lượng đặt hàng tối thiểu',
  选规格: 'Chọn',
  自提: 'Nhặt lên',
  不能输入小数: 'Không thể nhập số thập phân',
  '最多可填{{qualityPrecision}}位小数':
    'Có thể điền tối đa {{qualityPrecision}} chữ số thập phân',
  批量加购: 'Mua số lượng lớn',
  填写数量: 'Điền số lượng',
  确定: 'Xác nhận',
  以下规格库存不足: 'Các thông số kỹ thuật sau đã hết hàng',
  已自动修改数量: 'Số lượng đã được tự động sửa đổi',
  '库存不足，已修改下单数量':
    'Không đủ hàng tồn kho, số lượng đặt hàng đã được sửa đổi',
  '加载中…': 'Đang tải…',
  删除成功: 'Đã xóa thành công',
  库存: 'Tồn kho',
  购买数量: 'Số lượng',
  添加备注: 'Thêm ghi chú',
  最低起订量: 'MOQ',
  '，还差': ', thậm chí không đóng',
  '总 数': 'Qty',
  总金额: 'Total',
  移出购物车: 'Xóa khỏi giỏ hàng',
  请输入内容: 'Vui lòng nhập nội dung',
  输入内容: 'Nhập nội dung',
  海外发货: 'Giao hàng nước ngoài',
  国内发货: 'Giao hàng trong nước',
  单: 'đơn hàng',
  个: 'cái',
  上次价: 'Giá cuối cùng',
  暂无货品: 'Chưa có sản phẩm nào',
  '--- 已经到底啦 ---': '--- Hết rồi ---',
  搜索: 'Tìm kiếm',
  综合: 'tổng hợp',
  价格: 'giá cả',
  销售单数: 'số lượng đơn bán hàng',
  最新上架时间: 'ngày ra mắt sản phẩm mới',
  货名: 'tên sản phẩm',
  按: 'Dựa theo',
  排序: 'Loại',
  '按{{name}}排序': 'Sắp xếp theo {{name}}',
  库存小于起订量: 'Hàng tồn kho ít hơn MOQ',
  '起订量为{{minNumStep}}{{unitName}}':
    'Số lượng đặt hàng tối thiểu là {{minNumStep}}{{unitName}}',
  当前数量加上起订量后大于库存:
    'Số lượng hiện tại cộng với số lượng đặt hàng tối thiểu lớn hơn lượng hàng tồn kho',
  '最低起订量为{{minNumStep}}{{unitName}}':
    'Số lượng đặt hàng tối thiểu là {{minNumStep}}{{unitName}}',
  '最大库存为{{stock}}{{unitName}}':
    'Số hàng tồn kho tối đa là {{stock}}{{unitName}}',
  首页: 'Trang đầu',
  全部货品: 'Sản phẩm',
  购物车: 'Giỏ hàng',
  我的: 'Tôi',
  已下架: 'LOẠI BỎ',
  库存不足: 'Thiếu hàng tồn kho',
  已删除: 'Đã xóa',
  全部: 'Toàn bộ',
  买过: 'Đã mua',
  推荐: 'Gợi ý',
  新品: 'Sản phẩm mới',
  爆品: 'Vật phẩm nổ',
  促销: 'Khuyến mãi',
  销量: 'Sold',
  请求已过期: 'Yêu cầu đã hết hạn',
  进入店铺: 'Vào gian hàng',
  企业图片: 'Hình ảnh doanh nghiệp',
  企业介绍: 'Giới thiệu công ty',
  请求数据: 'Yêu cầu dữ liệu',
  加载下一页: 'Tải trang tiếp theo',
  '请求中loading...': 'Đang tải yêu cầu...',
  '请求出错了, {{msg}}': 'Đã xảy ra lỗi với yêu cầu, {{msg}}',
  列表数据为空: 'Dữ liệu danh sách trống',
  注册: 'Đăng ký',
  登录: 'Đăng nhập',
  重置密码: 'Đặt lại mật khẩu',
  获取验证码: 'Nhận được mã',
  重新发送: 'Gửi lại',
  '请输入新密码（4-16位）': 'Vui lòng nhập mật khẩu mới (4-16 chữ số)',
  '请输入密码（4-16位）': 'Vui lòng nhập mật khẩu (4-16 chữ số)',
  请输入密码: 'Xin vui lòng nhập mật khẩu',
  请输入手机: 'Vui lòng nhập số điện thoại di động',
  请输入手机或邮箱: 'Vui lòng nhập số điện thoại hoặc email',
  请再次输入密码: 'Vui lòng nhập lại mật khẩu',
  中文: 'Người Trung Quốc',
  越南语: 'Tiếng Việt',
  英文: 'Tiếng Anh',
  手机号为18位以内的数字: 'Số điện thoại di động phải là một số có 18 chữ số',
  请输入正确的手机号: 'Vui lòng nhập số điện thoại hợp lệ',
  请输入正确的邮箱号: 'Vui lòng nhập đúng địa chỉ email',
  请输入密码和确认密码: 'Vui lòng nhập mật khẩu và xác nhận mật khẩu',
  '密码为4~16位字符': 'Mật khẩu có 4~16 ký tự',
  两次输入的密码不一致: 'Mật khẩu nhập hai lần không nhất quán',
  请输入邀请码: 'Vui lòng nhập mã mời',
  '请先阅读并勾选《用户协议》和《隐私政策》':
    'Vui lòng đọc và kiểm tra "Thỏa thuận người dùng" và "Chính sách quyền riêng tư" trước',
  请输入验证码: 'Vui lòng nhập mã xác nhận',
  '密码修改成功 请用新密码登录':
    'Mật khẩu đã được thay đổi thành công. Vui lòng đăng nhập bằng mật khẩu mới.',
  用已有账号登录: 'Đăng nhập bằng tài khoản hiện có',
  新用户注册: 'Đăng ký mới',
  忘记密码: 'Quên mật khẩu',
  请填写邀请码: 'Vui lòng điền mã mời',
  已阅读并同意: 'Đã đọc và đồng ý',
  用户协议: 'Sự thỏa thuận của người dùng',
  和: 'Và',
  隐私政策: 'Chính sách bảo mật',
  退出登录: 'Đăng xuất',
  获取用户信息失败: 'Không thể lấy được thông tin người dùng',
  我的资料: 'Hồ sơ của tôi',
  点击登录: 'Bấm để đăng nhập',
  我的订单: 'Đơn hàng của tôi',
  待确认: 'Chờ xác nhận',
  待发货: 'Chờ giao hàng',
  '待收货/自提': 'Chờ nhận hàng/tự lấy',
  已完成: 'Đã hoàn thành',
  '退款/售后': 'Hoàn tiền/Sau bán hàng',
  上传中: 'Đang tải lên',
  上传头像失败: 'Không tải được hình đại diện lên',
  上传成功: 'Tải lên thành công',
  更新用户信息失败: 'Không cập nhật được thông tin người dùng',
  更换头像: 'Thay đổi hình đại diện',
  头像: 'Hình đại diện',
  姓名: 'Tên',
  公司: 'Công ty',
  手机: 'Điện thoại di động',
  邮箱: 'Thư',
  我的地址: 'Địa chỉ của tôi',
  待付款: 'Trong khi chờ thanh toán',
  配送中: 'Đang giao hàng',
  已发货: 'Đã vận chuyển',
  已取消: 'Đã hủy',
  '总额:': 'Số tiền gộp:',
  '总量:': 'Tổng cộng:',
  已作废订单不汇总统计: 'Đơn hàng bị hủy không có số liệu thống kê tóm tắt',
  物流选项: 'Tùy chọn vận chuyển',
  '地址:': 'Địa chỉ:',
  运输费: 'Phí vận chuyển',
  COD服务费: 'Phí dịch vụ COD',
  待自提: 'Được nhặt lên',
  待配送: 'Chờ giao hàng',
  已作废: 'Bãi bỏ',
  头程已发货: 'Chặng đầu tiên đã được xuất xưởng',
  已到中转仓: 'Đã đến kho trung chuyển',
  跨境运输中: 'Vận chuyển xuyên biên giới',
  退货退款: 'Hoàn tiền',
  下单成功: 'Đặt hàng thành công',
  '订单总共(': 'Tổng số đơn đặt hàng (',
  '项)': ' mục)',
  留言: 'Tin nhắn',
  '给订单留个言~': 'Để lại tin nhắn cho đơn hàng~',
  提交订单: 'Nộp đơn đặt hàng',
  货款: 'Thanh toán',
  运费: 'Vận chuyển hàng hóa',
  '合计：': 'Tổng cộng: ',
  合计: 'Tổng cộng',
  '点击“下单”即表示您同意': 'Bằng cách nhấp vào "Đặt hàng" bạn đồng ý',
  Epaifa的交易条款: 'Điều khoản giao dịch của Epaifa',
  结账: 'Thanh toán',
  下单: 'Đặt hàng',
  取消成功: 'Hủy thành công',
  货品已成功添加到购物车: 'Hàng đã được thêm vào giỏ hàng thành công',
  单据详情: 'Chi tiết tài liệu',
  'COD 服务费': 'Phí dịch vụ COD',
  总计: 'Tổng cộng',
  实收: 'Biên nhận thực tế',
  订单信息: 'Thông tin đặt hàng',
  店铺: 'Cửa hàng',
  订单号: 'Số thứ tự',
  交易时间: 'Giờ giao dịch',
  经手人: 'Người xử lý',
  备注: 'Ghi chú',
  再次购买: 'Mua lại',
  单据列表: 'Danh sách tài liệu',
  搜索订单: 'Tìm kiếm đơn hàng',
  日期: 'Ngày',
  没有更多了: 'Không còn nữa',
  '找不到订单哦~': 'Không tìm thấy đơn hàng~',
  联系我们: 'Liên hệ chúng tôi',
  查看订单: 'Kiểm tra đơn hàng',
  '运输费 {{currencySymbol}} {{slot1}} + COD服务费 {{currencySymbol}} {{slot2}}':
    'Phí vận chuyển {{currencySymbol}} {{slot1}} + phí dịch vụ COD {{currencySymbol}} {{slot2}}',
  价格不能小于0: 'Giá không thể nhỏ hơn 0',
  '最低价格需<=最高价格': 'Giá tối thiểu cần <= giá tối đa',
  '最高价格需>=最低价格': 'Giá cao nhất cần >= giá thấp nhất',
  '整数位不能超过{{integerMaxLength}}位':
    'Các bit số nguyên không thể vượt quá bit {{integerMaxLength}}',
  '小数位不能超过{{pricePrecision}}位':
    'Vị trí thập phân không được vượt quá vị trí {{pricePrecision}}',
  最低价格: 'Giá thấp nhất',
  最高价格: 'Giá cao nhất',
  发货类型: 'Loại vận chuyển',
  重置: 'Cài lại',
  '商品找不到了…': 'Không thể tìm thấy sản phẩm...',
  联系: 'Liên hệ',
  库存不足无法下单: 'Không đủ hàng, không thể đặt hàng',
  '添加成功，在购物车等你': 'Đã thêm thành công, đang chờ bạn trong giỏ hàng',
  选购: 'Cửa hàng',
  筛选: 'chọn lọc',
  '支持货名/属性/条码': 'Hỗ trợ tên sản phẩm/thuộc tính/mã vạch',
  最近搜索: 'Tìm kiếm gần đây',
  删除: 'Xóa bỏ',
  当前商品下架已删除: 'Sản phẩm hiện tại đã được gỡ bỏ khỏi kệ',
  '确认删除货品吗？': 'Bạn có chắc chắn xóa mục này không?',
  全选: 'Chọn tất cả',
  '已选：': 'Đã chọn: ',
  是否清空失效货品: 'Có nên thanh lý hàng hết hạn sử dụng không',
  清空成功: 'Đã xóa thành công',
  货品冲突: 'Xung đột sản phẩm',
  '{{infoChangeCount}}件货品档案变更，':
    'Thay đổi tệp mục {{infoChangeCount}},',
  '{{stockCount}}件货品库存不足，': '{{stockCount}} mặt hàng đã hết hàng.',
  '{{deleteCount}}件货品下架或删除，':
    '{{deleteCount}} mục đã bị gỡ khỏi kệ hoặc bị xóa.',
  '{{deleteCount}}个货品已下架或库存不足，是否删除？':
    '{{deleteCount}} sản phẩm đã bị gỡ bỏ hoặc hết hàng, bạn có muốn xóa chúng không?',
  是否删除: 'Bạn có muốn xóa',
  件失效货品: ' Hàng bị lỗi',
  清空: 'Thông thoáng',
  '购物车还是空的呐～': 'Giỏ hàng vẫn trống~',
  新: 'Mới',
  爆: 'Nổ',
  荐: 'Gợi ý',
  促: 'Khuyến mãi',
  '登录已过期，请重新登录': 'Đăng nhập đã hết hạn, vui lòng đăng nhập lại',
  '出错了，请检查网络连接或重试':
    'Đã xảy ra lỗi, vui lòng kiểm tra kết nối mạng của bạn hoặc thử lại',
  '{{err}}，请检查网络连接或重试':
    '{{err}}, vui lòng kiểm tra kết nối mạng hoặc thử lại',
  '{{msg}}，请检查网络连接或重试':
    '{{msg}}, vui lòng kiểm tra kết nối mạng của bạn hoặc thử lại',
  '出错了~': 'Có gì đó không ổn~',
  大额订单说明: 'Hướng dẫn đặt hàng lớn',
  '订单超过1亿，店长会主动联系您协助完成交易':
    'Với những đơn hàng trên 100 triệu, quản lý cửa hàng sẽ chủ động liên hệ với bạn để hỗ trợ hoàn tất giao dịch.',
  '超低价格，品质保证': 'Giá cực rẻ, đảm bảo chất lượng',
  海外: 'Hải ngoại',
  保税仓库: 'Kho ngoại quan',
  胡志明市: 'Ho Chi Minh City',
  运费信息: 'Thông tin vận chuyển',
  邮寄方式: 'Phương pháp vận chuyển',
  可用的: 'Có sẵn',
  成本: 'Giá thành',
  服务费: 'phi dịch vụ',
  任何数量: 'Số lượng bất kỳ',
  购买: 'Mua',
  货品属性: 'Thuộc tính vật phẩm',
  已指派专门的销售代表与您跟进:
    'Một đại diện bán hàng tận tâm đã được chỉ định để theo dõi bạn',
  货品总计: 'Tổng số đơn đặt hàng',
  项: 'món',
  装箱规格: 'bao bì',
  补货中: 'Đang bổ sung hàng',
  请选择下单货品: 'Vui lòng chọn sản phẩm để đặt hàng',
  请填写姓名: 'Vui lòng điền tên của bạn',
  请填写联系电话: 'Vui lòng điền số điện thoại liên lạc của bạn',
  请填写收货地址: 'Vui lòng điền địa chỉ giao hàng của bạn',
  搜索货品: 'Tìm kiếm sản phẩm',
  请输入数字: 'Vui lòng nhập số',
  体验一下: 'Trải nghiệm thử',
  请输入正确的手机号码: 'Vui lòng nhập số điện thoại hợp lệ',
  请输入正确的邮箱地址: 'Vui lòng nhập địa chỉ email hợp lệ',
  多语言: 'Đa ngôn ngữ',
  共: 'Tổng cộng',
  种: 'Loại',
  不含税: 'Không bao gồm VAT',
  订单金额不在COD范围内: 'Số tiền đơn hàng không nằm trong phạm vi COD',
  更多: 'Hơn',
  获取: 'Lấy',
  获取邀请码: 'Nhận một mã mời',
  申请邀请码: 'Yêu cầu nhận một mã mời',
  'Zalo扫一扫，加我为好友': 'Quét để thêm tôi làm bạn trên Zalo',
  预计送达: 'Nhận trước ngày',
  请选择物流: 'Vui lòng chọn hậu cần',
  首页模块为空: 'Mô-đun trang chủ trống',
  重量: 'Cân nặng',
  体积: 'Âm lượng',
  探索数以百万计的定制产品满足您的业务需求:
    'Khám phá hàng triệu dịch vụ được thiết kế riêng theo nhu cầu kinh doanh của bạn',
  推荐货品: 'Sản phẩm khuyến cáo',
  手机登录: 'Đăng nhập bằng điện thoại',
  邮箱登录: 'Đăng nhập bằng email',
  门店: 'Cửa hàng',
  仓库分拣中: 'Sắp xếp trong kho',
  分拣中: 'Đang sắp xếp',
  退货中: 'Trở về',
  采购中: 'Đang mua',
  分类: 'Phân loại',
  退换货: 'Trả hàng',
  退换单: 'Trả hàng',
  上传图片失败: 'Không tải được hình ảnh lên',
  批发价: 'Bán hàng tháng',
  复购率: 'Tỷ lệ mua lại',
  月销量: 'Bán hàng tháng',
  没有找到相关商品: 'Không tìm thấy sản phẩm liên quan',
  商品总金额: 'Thanh toán',
  优惠: 'Ưu đãi',
  '实付：': 'Thanh toán:',
  退款成功: 'Hoàn tiền thành công',
  退货成功: 'Trả hàng thành công',
  退货关闭: 'Đóng trả hàng',
  请选择站点: 'Vui lòng chọn trang web',
  分享: 'Chia sẻ',
  下载所有图片: 'Tải xuống tất cả hình ảnh',
  相册: 'Album',
  正在下载: 'Đang tải',
  '下载完成，在相册查看': 'Tải xuống hoàn tất, xem trong album',
  新品2: 'Sản phẩm mới',
  商品分类: 'Danh mục sản phẩm',
  暂无商品2: 'Chưa có sản phẩm',
  '生成图片中…': 'Đang tạo hình ảnh…',
  '新品相册！快来看看！': 'Album mới! Hãy xem!',
  新品分享: 'Chia sẻ sản phẩm mới',
  扫码查看: 'Quét mã để xem',
  下载图片: 'Tải hình ảnh',
  分享链接: 'Chia sẻ liên kết',
  好物分享: 'Chia sẻ sản phẩm',
  下载: 'Tải xuống',
  货品详情: 'Chi tiết sản phẩm',
  查看新品: 'Xem sản phẩm mới',
  不含运费: 'Miễn phí vận chuyển',
  '新品分享，点击查看': 'Chia sẻ sản phẩm mới, nhấp để xem',
}
